export function initFancyboxSizing() {
  if (typeof window !== 'undefined' && window.Fancybox && !window.__rtFancyboxInit) {
    window.__rtFancyboxInit = true;

    // Bind Fancybox to elements with data-fancybox attribute
    window.Fancybox.bind('[data-fancybox]', {
      // Enable drag to close
      dragToClose: true,

      // Default type for YouTube URLs
      defaultType: 'iframe',

      // Make iframe take up 80% of screen
      width: '80vw',
      height: '80vh',

      // Iframe configuration
      iframe: {
        preload: false,
      },

      // Enable toolbar with close button
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close']
        }
      },

      // Localization
      l10n: {
        CLOSE: 'Close'
      }
    });

    // Add custom CSS for better styling
    const style = document.createElement('style');
    style.textContent = `
      .fancybox__backdrop {
        background: rgba(0,0,0,0.85) !important;
      }

      .fancybox__content {
        border-radius: 0 !important;
        width: 80vw !important;
        height: 80vh !important;
        max-width: none !important;
        max-height: none !important;
      }

      .fancybox__content iframe {
        width: 100% !important;
        height: 100% !important;
      }

      .fancybox__slide {
        padding: 0 !important;
      }

      .fancybox__button--close {
        background: rgba(0,0,0,0.8) !important;
        color: white !important;
        border-radius: 0 !important;
        top: 10px !important;
        right: 10px !important;
        z-index: 9999 !important;
      }

      .fancybox__button--close:hover {
        background: rgba(0,0,0,0.9) !important;
      }
    `;
    document.head.appendChild(style);
  }
}

// Auto-initialize when DOM is ready
export function autoInitFancybox() {
  if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFancyboxSizing);
    } else {
      // DOM already loaded, check if Fancybox is available
      const checkFancybox = () => {
        if (window.Fancybox) {
          initFancyboxSizing();
        } else {
          // Retry after a short delay
          setTimeout(checkFancybox, 100);
        }
      };
      checkFancybox();
    }
  }
}